import React from 'react';
import './ui.css';

const TextArea = ({ label, error, className = '', ...props }) => (
  <div className="pn-field">
    {label ? <label className="pn-label">{label}</label> : null}
    <textarea className={`pn-textarea ${className}`.trim()} {...props} />
    {error ? <p className="pn-field-error">{error}</p> : null}
  </div>
);

export default TextArea;
